module.exports = __webpack_public_path__ + "static/img/area-bg.d045216.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/area-bg.png
// module id = Puks
// module chunks = 1